// Function to open the popup
function openPopup() {
    var popup = document.querySelector('.tuotelomake-popup');
    if (popup) {
        popup.classList.add('open');
        document.documentElement.classList.add('is-active-popup');
    }
}

// Function to close the popup
function closePopup() {
    var popup = document.querySelector('.tuotelomake-popup');
    //var popupresponse = document.querySelector('#popupresponse');
    if (popup) {
        popup.classList.remove('open');
        document.documentElement.classList.remove('is-active-popup');
        //popupresponse.innerHTML = "";
    }
}




document.addEventListener("DOMContentLoaded", function () {
    var openPopupButtons = document.querySelectorAll('.openpopup');
    openPopupButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var tuotenimi = button.getAttribute("tuotenimi");

            var interestedInProductField = document.querySelector('input[name="fmf_interestedinproduct"]');

            if (interestedInProductField) {
                interestedInProductField.value = tuotenimi || "";
            }

            openPopup(); // Ensure this function exists
        });
    });

    // Close popup event listener
    var closePopupButton = document.querySelector('.closepopup');
    if (closePopupButton) {
        closePopupButton.addEventListener('click', closePopup);
    }
});
